import moment from 'moment';

const ageGateForm = document.querySelector('.js-age-gate-form');
if (ageGateForm) {
	ageGateForm.addEventListener('submit', (e) => {
		e.preventDefault();

		const dob = ageGateForm.querySelector('input[name="dob"]');
		const email = ageGateForm.querySelector('input[name="email"]');

		if (isOverEighteen(dob.value)) {
			localStorage.setItem('ageGate', 'passed');
			localStorage.setItem('dob', dob.value);
			localStorage.setItem('email', email.value);
			document.querySelector('input[name="atreemo_email"]').value = email.value;

			document.querySelector('.js-age-gate').classList.remove('is-active');
		} else {
		}
	});
}

function showAgeGate() {
	if (localStorage.getItem('ageGate')) return;
	setTimeout(() => {
		document.querySelector('.js-age-gate').classList.add('is-active');
	}, 1000);
}

function isOverEighteen(dob) {
	const age = moment().diff(moment(dob, 'YYYY-MM-DD'), 'years');
	return age >= 18 ? true : false;
}

export { showAgeGate, isOverEighteen };
